<template>
    <div class="page-cars">
        <el-dialog
                title="Добавить автомобиль"
                :visible.sync="addVisible"
                width="435px"
        >
            <div>
                <el-form class="m-t-10" ref="validationForm" :model="model" v-loading="loading">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="Марка автомобиля" prop="Model" :rules="[{ required: true, message: 'Марка автомобиля не заполнена' }]">
                                <el-input v-model="model.Model" placeholder="Марка автомобиля"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Гос. номер" prop="Plate" :rules="[{ required: true, message: 'Гос. номер не заполнен' }]">
                                <el-input v-model="model.Plate" placeholder="Гос. номер"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="ID карты" prop="CardID" :rules="[{ required: true, message: 'ID не заполнен' }]">
                                <el-input v-model="model.CardID" placeholder="ID карты"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Цвет" prop="Color" :rules="[{ required: true, message: 'Цвет не указан' }]">
                                <el-color-picker v-model="model.Color"></el-color-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12" align="left" class="d-flex align-items-left">
                            <el-form-item label="" prop="AllowPassageByPlate" class="m-b-0">
                                <el-checkbox class="m-l-0" v-model="model.AllowPassageByPlate">Разрешить въезд</el-checkbox>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" align="right" class="d-flex align-items-right">
                            <el-button type="primary" class="w-100" icon="el-icon-plus" @click="add" :loading="loading">Добавить</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </el-dialog>

        <el-card v-if="$loginType() !== 4" shadow="never" class="m-b-20">
            <el-row :gutter="20">
                <el-col :sm="24" :md="12" :lg="18" :xl="18" class="m-b-10 m-b-md-0">
                    <el-input placeholder="Искать автомобиль"
                              v-model="form.SearchString"
                              v-on:change="getData"
                              clearable>
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                </el-col>
                <el-col :sm="24" :md="12" :lg="6" :xl="6" align="right" class="d-flex">
                    <el-button class="w-50" type="primary" @click="handleFilter" icon="icon-search">Поиск</el-button>
                    <el-button class="w-50" @click="addForm" icon="icon-plus">Добавить</el-button>
                </el-col>
            </el-row>
        </el-card>
        <el-row :gutter="20">
            <el-col :span="24">
                <el-table v-loading="loading" :data="dataTable">
                    <el-table-column prop="Model" label="Модель">
                        <template slot-scope="scope">
                            <div class="font-weight-bold">
                                <a href="#" @click.prevent="showDetails(scope.row.ID)" class="color-black">
                                    {{ scope.row.Model }}
                                </a>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Plate" label="Гос. Номер" />
                    <el-table-column prop="Color" label="Цвет" v-if="$mobile()">
                        <template slot-scope="scope">
                            <div class="car-color" :style="{ backgroundColor: $getColor(scope.row.Color) }">
                                &nbsp;
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="AllowPassageByPlate" label="Проезд по гос.номеру" v-if="$mobile() && $loginType() !== 4">
                        <template slot-scope="scope">
                            <div v-if="scope.row.AllowPassageByPlate" class="font-weight-bold color-success">
                                Да
                            </div>
                            <div v-else class="font-weight-bold color-danger">
                                Нет
                            </div>
                        </template>
                    </el-table-column>
<!--                    <el-table-column-->
<!--                        v-if="$loginType() === 4"-->
<!--                        label="Оплата"-->
<!--                        width="80px"-->
<!--                    >-->
<!--                        <template slot-scope="scope">-->
<!--                            <el-button @click="$router.push({ name: 'payCard', query: { cardId: scope.row.CardID }})" icon="icon-payment-card" class="el-button&#45;&#45;icon" size="mini" title="Оплатить"></el-button>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
                    <el-table-column
                            v-if="$loginType() === 1"
                            fixed="right"
                            label=""
                            width="80px"
                            align="right"
                    >
                        <template slot-scope="scope">
                            <el-button @click="deleteItem(scope.row.ID)" icon="icon-trash" class="el-button--icon" size="mini" title="Удалить"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="m-t-20 text-center">
                    <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="form.Page"
                            :page-sizes="[10, 20, 100, 200, 300, 400]"
                            :page-size="form.PageSize"
                            layout="sizes, prev, pager, next, total"
                            :total="total">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import Vue from 'vue'

    export default {
        data () {
            return {
                loading: false,
                form: {
                    From: Vue.moment().add(-30, 'days').format('DD/MM/YYYY HH:mm'),
                    To: Vue.moment().hour('23').minutes('59').format('DD/MM/YYYY HH:mm'),
                    SearchString: '',
                    Page: 1,
                    PageSize: 20
                },
                total: 0,
                dataTable: [],
                tarifDict: '',
                editMode: false,
                addVisible: false,
                model: {
                    Color: '#409EFF'
                }
            }
        },
        created () {
            this.getTarif()
            this.getData()
        },
        methods: {
            changeDate (date) {
                this.form.From = date[0]
                this.form.To = date[1]
                this.getData()
            },
            handleSizeChange (val) {
                this.form.PageSize = val
                this.getData()
            },
            handleCurrentChange (val) {
                this.form.Page = val
                this.getData()
            },
            handleFilter () {
                this.getData()
            },
            getData () {
                this.loading = true

                let request = Object.assign({
                    Name: "GetItemsList",
                    ItemType: "Car"
                }, this.form)

                this.$api.Main.getCars(request).then(response => {
                    this.loading = false
                    this.dataTable = response.Items
                    this.total = response.Total
                }).catch (() => {
                    this.loading = false
                })
            },
            getTarif () {
                this.$api.Main.getTarif().then(response => {
                    this.tarifDict = response.Items
                })
            },
            showDetails (id) {
                this.$router.push({ name: 'carDetails', params: { id: id } })
            },
            add () {
                this.$refs['validationForm'].validate((valid) => {
                    if (valid) {
                        this.clearFormErrors('validationForm')
                        this.loading = true

                        let request = Vue.$props('AddItem', 'Car', this.model)

                        this.$api.Main.addCard(request).then(response => {
                            this.loading = false

                            if (response.Result === "Success") {
                                this.resetForm()
                                this.$message({
                                    message: 'Автомобиль добавлен',
                                    type: 'success',
                                    res: response
                                })

                                this.addVisible = false
                                this.getData()

                                setTimeout(() => this.clearFormErrors('validationForm'), 500)
                            }
                            else {
                                this.$message({
                                    message: response.ErrorString,
                                    type: 'error',
                                    res: response
                                })
                            }
                        }).catch((error) => {
                            this.loading = false
                            this.showFormErrors(error, 'validationForm')
                        })
                    }
                })
            },
            addForm () {
                this.resetForm()
                setTimeout(() => this.clearFormErrors('validationForm'), 1)
                this.editMode = false
                this.addVisible = true
            },
            close() {
                this.addVisible = false
                this.resetForm()
                setTimeout(() => this.clearFormErrors('validationForm'), 500)
            },
            resetForm () {
                this.model = {
                    CardID: '',
                    Model: '',
                    Color: '',
                    Plate: '',
                    AllowPassageByPlate: false
                }
            },
            deleteItem (id) {
                this.$confirm('Вы уверены что хотите удалить автомобиль?').then(() => {
                    let request = {
                        Name: "RemoveItem",
                        ItemType: "Car",
                        ItemId: id
                    }

                    this.$api.Main.deleteCar(request).then(response => {
                        if (response.Result === 'Failed') {
                            this.$message({
                                message: response.ErrorString,
                                type: 'error'
                            })
                        }
                        else {
                            this.$message({
                                message: 'Автомобиль удален',
                                type: 'success',
                                res: response
                            })
                            this.getData()
                        }
                    })
                })
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>
